import { Field, useFormState } from "react-final-form";
import { useIntl } from "react-intl";
import * as Validations from "../../../common/form/validator";
import { TextInput, DropdownInput } from "../../../common/fields";

const AdminUserDetailsForm = ({
  departments,
  designations,
  roles,
  error,
  action,
  requesting,
  disabled = false,
  isEdit = false,
}) => {
  const intl = useIntl();
  const formState = useFormState();

  let emailMeta = {
    error: formState?.errors?.email,
    touched: formState?.touched?.email,
  };
  if (
    error?.response === "DUPLICATE_EMAIL" &&
    action === "create" &&
    !requesting
  ) {
    emailMeta = {
      error: "emailExists",
      touched: true,
    };
  }

  return (
    <div className="grid">
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="email"
          component={TextInput}
          type="email"
          icon="pi-envelope"
          placeholder={intl.formatMessage({
            id: "email",
          })}
          label={intl.formatMessage({
            id: "email",
          })}
          disabled={disabled}
          readOnly={isEdit}
          meta={emailMeta}
          required
          validate={Validations.composeValidators(
            Validations.required,
            Validations.checkEmailFormat
          )}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="name"
          component={TextInput}
          type="text"
          label={intl.formatMessage({
            id: "name",
          })}
          disabled={disabled}
          placeholder={intl.formatMessage({
            id: "name",
          })}
          required
          validate={Validations.composeValidators(Validations.required)}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="role"
          component={DropdownInput}
          options={roles}
          label={intl.formatMessage({
            id: "role",
          })}
          disabled={disabled}
          placeholder={intl.formatMessage({
            id: "role",
          })}
          required
          validate={Validations.composeValidators(Validations.required)}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="phoneNumber"
          component={TextInput}
          type="number"
          placeholder={intl.formatMessage({
            id: "phoneNumber",
          })}
          disabled={disabled}
          label={intl.formatMessage({
            id: "phoneNumber",
          })}
          maxLength={10}
          validate={Validations.composeValidators(Validations.maxLength(10))}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="designation"
          component={DropdownInput}
          options={designations}
          editable={true}
          optionLabel="value"
          placeholder={intl.formatMessage({
            id: "designation",
          })}
          disabled={disabled}
          label={intl.formatMessage({
            id: "designation",
          })}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="department"
          component={DropdownInput}
          options={departments}
          optionLabel="value"
          editable={true}
          placeholder={intl.formatMessage({
            id: "department",
          })}
          disabled={disabled}
          label={intl.formatMessage({
            id: "department",
          })}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-4">
        <Field
          name="profileType"
          component={DropdownInput}
          options={[
            {
              id: 1,
              name: "Local",
            },
          ]}
          disabled={disabled}
          placeholder={intl.formatMessage({
            id: "profile_type",
          })}
          label={intl.formatMessage({
            id: "profile_type",
          })}
          required
          validate={Validations.composeValidators(Validations.required)}
        />
      </div>
    </div>
  );
};

export default AdminUserDetailsForm;
